<h2>Маркет</h2>
<div class="container moderation-wrapper">
  <button mat-stroked-button color="primary" (click)="openCheckUserSteam()">Check User Steam</button>
  <nav mat-tab-nav-bar class="moderation-navigations">
    <div *ngFor="let link of navLinks" class="button-link">
      <a mat-tab-link
         [routerLink]="link.link"
         routerLinkActive #rla="routerLinkActive"
         [active]="rla.isActive"> {{link.label}}
      </a>
    </div>
  </nav>

  <div class="moderation-container">
    <router-outlet></router-outlet>
  </div>
</div>
